import { Box } from '@pets-ui/Box/Box'
import { CircularProgress } from '@pets-ui/CircularProgress/CircularProgress'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type PropsWithChildren } from 'react'

const styles = stylex.create({
  root: {
    backgroundColor: colors.white,
    height: '100%',
    width: '100%',
  },
  transparent: {
    backgroundColor: colors.grey800,
    opacity: 0.15,
  },
  circularProgress: {
    position: 'absolute',
    zIndex: 1001,
    left: 'calc(50% - 20px)',
    top: 'calc(50% - 20px)',
  },
  drop: {
    borderRadius: 8,
    backgroundColor: colors.white,
    position: 'absolute',
    zIndex: 1000,
    height: '100%',
    left: 0,
    top: 0,
    width: '100%',
  },
})

interface LoadingProviderProps extends PropsWithChildren {
  loading: boolean
  transparent?: boolean
}

export function LoadingProvider(props: LoadingProviderProps) {
  const { loading = true, transparent = false, children } = props
  return (
    <Box
      {...stylex.props([
        styles.root,
        transparent && styles.transparent,
      ])}
    >
      <Box {...stylex.props([loading && styles.drop])} />
      {loading && <CircularProgress fontSize={40} rootStyle={styles.circularProgress} color={transparent ? colors.white : colors.grey500} />}
      {children}
    </Box>
  )
}
